// ── LOGOS TTA ──────────────────────────────────────────
import ttaLogoLight from './images/logos/tta-logo-light.png';
import ttaLogoDark from './images/logos/tta-logo-dark.png';
import ttaFavicon from './images/logos/favicon.png';

// ── HERO ───────────────────────────────────────────────
import heroImage from './images/hero/hero-image.png';

// ── ALUMNI ─────────────────────────────────────────────
import alumni001 from './images/alumni/alumni-001.jpg';
import alumni002 from './images/alumni/alumni-002.jpg';
import alumni003 from './images/alumni/alumni-003.jpg';
import alumni004 from './images/alumni/alumni-004.jpg';
import alumni005 from './images/alumni/alumni-005.jpg';
import alumni006 from './images/alumni/alumni-006.jpg';

// ── PARTENAIRES — light (sur fond #8BC53F) ─────────────
import logoGizLight from './images/partners/logo-giz-light.png';
import logoForprodeLight from './images/partners/logo-forprode-light.png';
import logoAtosLight from './images/partners/logo-atos-light.png';
import logoSiraLabsLight from './images/partners/logo-sira-labs-light.png';

// ── PARTENAIRES — dark (sur fond #243828) ──────────────
import logoGizDark from './images/partners/logo-giz-dark.png';
import logoFoprodeDark from './images/partners/logo-forprode-dark.png';
import logoAtosDark from './images/partners/logo-atos-dark.png';
import logoSiraLabsDark from './images/partners/logo-sira-labs-dark.png';

// ── SECTIONS ───────────────────────────────────────────
import sectionImage002 from './images/sections/image-002.png';
import sectionImage003 from './images/sections/image-003.png';
import sectionImage004 from './images/sections/image-004.png';
import sectionImage005 from './images/sections/image-005.png';

// ── FORMATION HEROES ───────────────────────────────────
import formationHero001 from './images/formations/formation-hero-001.png';
import formationHero002 from './images/formations/formation-hero-002.png';
import formationHero003 from './images/formations/formation-hero-003.png';
import formationHero004 from './images/formations/formation-hero-004.png';
import formationHero005 from './images/formations/formation-hero-005.png';

// ── PROJETS ────────────────────────────────────────────
import fp40ia001 from './images/projets/forprode-40-ia/fp40ia-001.png';
import fp40ia002 from './images/projets/forprode-40-ia/fp40ia-002.png';
import fp40ia003 from './images/projets/forprode-40-ia/fp40ia-003.png';
import fp40iaContactFormImg from './images/projets/forprode-40-ia/fp40ia-contact-form-img.png';
import fp40iaFooterBanner from './images/projets/forprode-40-ia/fp40ia-footer-banner.png';
import ada001 from './images/projets/atos-digital-academy/ADA_001.jpg';
import ada002 from './images/projets/atos-digital-academy/ADA_002.jpg';
import ada003 from './images/projets/atos-digital-academy/ADA_003.jpg';
import ada004 from './images/projets/atos-digital-academy/ADA_004.jpg';
import ada005 from './images/projets/atos-digital-academy/ADA_005.jpg';
import ada006 from './images/projets/atos-digital-academy/ADA_006.jpg';
import ada007 from './images/projets/atos-digital-academy/ADA_007.jpg';
import ada008 from './images/projets/atos-digital-academy/ADA_008.jpg';

// ── BLOG IMAGES ────────────────────────────────────────
import blogImage001 from './images/blog/blog-001.jpg';
import blogImage002 from './images/blog/blog-002.jpg';
import blogImage003 from './images/blog/blog-003.jpg';
import blogImage004 from './images/blog/blog-004.jpg';
import blogImage005 from './images/blog/blog-005.jpg';
import blogImage006 from './images/blog/blog-006.jpg';

// ── EXPORTS ────────────────────────────────────────────
export const logos = {
  light: ttaLogoLight,
  dark: ttaLogoDark,
  favicon: ttaFavicon,
};

export const hero = {
  main: heroImage,
};

export const alumni = [
  alumni001, alumni002, alumni003,
  alumni004, alumni005, alumni006,
];

export const partnersLight = [
  { src: logoGizLight,       alt: 'GIZ' },
  { src: logoForprodeLight,  alt: 'FORPRODE' },
  { src: logoAtosLight,      alt: 'Atos' },
  { src: logoSiraLabsLight,  alt: 'Sira Labs' },
];

export const partnersDark = [
  { src: logoGizDark,        alt: 'GIZ' },
  { src: logoFoprodeDark,    alt: 'FORPRODE' },
  { src: logoAtosDark,       alt: 'Atos' },
  { src: logoSiraLabsDark,   alt: 'Sira Labs' },
];

export const sections = {
  image002: sectionImage002,
  image003: sectionImage003,
  image004: sectionImage004,
  image005: sectionImage005,
};

export const blogImages = {
  'blog-001': blogImage001,
  'blog-002': blogImage002,
  'blog-003': blogImage003,
  'blog-004': blogImage004,
  'blog-005': blogImage005,
  'blog-006': blogImage006,
};

export const fp40iaImages = {
  img001: fp40ia001,
  img002: fp40ia002,
  img003: fp40ia003,
  contactFormImg: fp40iaContactFormImg,
  footerBanner: fp40iaFooterBanner,
};

export const adaImages = [ada001, ada002, ada003, ada004, ada005, ada006, ada007, ada008];

export const formationHeroes = {
  'full-stack-ai':       formationHero001,
  'genai-machine-learning': formationHero002,
  'data-analytics':      formationHero003,
  'html-css-javascript': formationHero004,
  'python-fondamentaux': formationHero005,
};
